enum STOCK_STATUS {
  'No Stock' = 'NOT_AVAILABLE',
  'Low Stock' = 'LOW_STOCK',
  'High Stock' = 'AVAILABLE',
}

export { STOCK_STATUS };
